import React from "react";
import PropTypes from "prop-types";
import { FormattedNumber } from "react-intl";

const Percent = ({ value }) => (
  <FormattedNumber
    value={value}
    // eslint-disable-next-line react/style-prop-object
    style="percent"
    currency="EUR"
  />
);

Percent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Percent;
